<template>
  <div></div>
</template>

<script>
import { getSSO } from '@/api/user'
import { setToken } from '@/libs/util'

export default {
  name: 'Sso',
  data () {
    return {
      token: ''
    }
  },
  methods: {
    getSSO () {
      getSSO(this.token).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        setToken(res.result.token)
        this.$parent.getUserInfo()
        location.href = '/#/product'
      })
    }
  },
  mounted () {
    this.token = this.$route.params.token
    this.getSSO()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sso.vue